/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {BulkProgress} from '../models/BulkProgress';
import type {Error} from '../models/Error';
import type {UpdateUserEntitlementsRelation} from '../models/UpdateUserEntitlementsRelation';
import type {UpdateUserEntitlementsResult} from '../models/UpdateUserEntitlementsResult';

export interface BulkProductDischargeUserEntitlements$Request {
    updateUserEntitlementsRelation: UpdateUserEntitlementsRelation;
    reason?: string;
}

export interface BulkProductDischargeUserEntitlements$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const bulkProductDischargeUserEntitlementsRequest = createAction<PayloadData<void, BulkProductDischargeUserEntitlements$Request>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__REQUEST');
export const bulkProductDischargeUserEntitlementsSuccess = createAction<PayloadData<string, BulkProductDischargeUserEntitlements$Request>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__SUCCESS');
export const bulkProductDischargeUserEntitlementsFailure = createAction<PayloadData<Error, BulkProductDischargeUserEntitlements$Request, true>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__FAILURE');

export const bulkProductDischargeUserEntitlementsActions = [
    bulkProductDischargeUserEntitlementsRequest,
    bulkProductDischargeUserEntitlementsSuccess,
    bulkProductDischargeUserEntitlementsFailure
] as const;

/**
 * @param {UpdateUserEntitlementsRelation} meta.updateUserEntitlementsRelation
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const bulkProductDischargeUserEntitlements = (meta: BulkProductDischargeUserEntitlements$Request, config?: BulkProductDischargeUserEntitlements$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
    };
    return {
        CALL_API: {
            types: bulkProductDischargeUserEntitlementsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            TRANSPORT_REQUEST_BODY: meta.updateUserEntitlementsRelation,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductDischargeUserEntitlementsProgress$Request {
    id: string;
}

export interface GetProductDischargeUserEntitlementsProgress$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductDischargeUserEntitlementsProgressRequest = createAction<PayloadData<void, GetProductDischargeUserEntitlementsProgress$Request>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_USER_ENTITLEMENTS_PROGRESS__REQUEST');
export const getProductDischargeUserEntitlementsProgressSuccess = createAction<PayloadData<BulkProgress, GetProductDischargeUserEntitlementsProgress$Request>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_USER_ENTITLEMENTS_PROGRESS__SUCCESS');
export const getProductDischargeUserEntitlementsProgressFailure = createAction<PayloadData<Error, GetProductDischargeUserEntitlementsProgress$Request, true>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_USER_ENTITLEMENTS_PROGRESS__FAILURE');

export const getProductDischargeUserEntitlementsProgressActions = [
    getProductDischargeUserEntitlementsProgressRequest,
    getProductDischargeUserEntitlementsProgressSuccess,
    getProductDischargeUserEntitlementsProgressFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductDischargeUserEntitlementsProgress = (meta: GetProductDischargeUserEntitlementsProgress$Request, config?: GetProductDischargeUserEntitlementsProgress$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductDischargeUserEntitlementsProgressActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/users/entitlements/discharge/progress`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductDischargeUserEntitlementsResult$Request {
    id: string;
}

export interface GetProductDischargeUserEntitlementsResult$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductDischargeUserEntitlementsResultRequest = createAction<PayloadData<void, GetProductDischargeUserEntitlementsResult$Request>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_USER_ENTITLEMENTS_RESULT__REQUEST');
export const getProductDischargeUserEntitlementsResultSuccess = createAction<PayloadData<UpdateUserEntitlementsResult, GetProductDischargeUserEntitlementsResult$Request>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_USER_ENTITLEMENTS_RESULT__SUCCESS');
export const getProductDischargeUserEntitlementsResultFailure = createAction<PayloadData<Error, GetProductDischargeUserEntitlementsResult$Request, true>>('BULK_PRODUCT_DISCHARGE_USER_ENTITLEMENTS__GET_PRODUCT_DISCHARGE_USER_ENTITLEMENTS_RESULT__FAILURE');

export const getProductDischargeUserEntitlementsResultActions = [
    getProductDischargeUserEntitlementsResultRequest,
    getProductDischargeUserEntitlementsResultSuccess,
    getProductDischargeUserEntitlementsResultFailure
] as const;

/**
 * @param {string} meta.id Bulk operation id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductDischargeUserEntitlementsResult = (meta: GetProductDischargeUserEntitlementsResult$Request, config?: GetProductDischargeUserEntitlementsResult$Config) => {
    const TRANSPORT_GET_PARAMS = {
        id: meta.id,
    };
    return {
        CALL_API: {
            types: getProductDischargeUserEntitlementsResultActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/users/entitlements/discharge`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

